import React, { useRef, useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import style from "../CSD/csd.module.scss";
import "../CSD/InstanceForms.scss";
import {
  I2cAccordionStepItem,
  I2cAccordionSteps,
  I2cButton,
  I2cSidebar,
  I2cCard,
  I2cTooltip,
  I2cIcon,
  I2cProgressBar,
} from "@webcomponents/i2cwebcomponents/dist/react";
import SecureHeader from "../../Components/SecureHeader/SecureHeader";
import ProgramInfo from "../CreditForm/ProgramInformation/ProgramInformation";
import GeneralInfoProgramFeatures from "../CreditForm/ProgramFeatures/GeneralInformation";
import ProgramVelocity from "./ProgramFeatures/ProgramVelocityLimits";
import OptionalFeatures from "../PrepaidComponents/OptionalFeatures";
import InterfacesAndComponents from "../PrepaidComponents/InterfacesAndComponents/Index";
import AdditionalComment from "../PrepaidComponents/AdditionalComments/AdditionalComment";
import CompletionAndSignOff from "../PrepaidComponents/CompletionListAndSignOff/CompletionListAndSignOff";
import SalesService from "../../Services/SalesService";
import ProjectDetails from "../PrepaidComponents/GeneralInformation/ProjectDetails";
import ContractAndPaymentTerms from "../PrepaidComponents/GeneralInformation/ContractAndPaymentTerms";
import CompanyInformation from "../PrepaidComponents/GeneralInformation/CompanyInformation";
import ContactInformation from "../PrepaidComponents/CompanyProfile/ContactInformation";
import FinancialInstitution from "../PrepaidComponents/CompanyProfile/FinancialInstitution";
import CardNetwork from "../PrepaidComponents/CardNetworkAndBinInfo/CardNetwork";
import FraudManagement from "../PrepaidComponents/OptionalFeatures/FraudManagementService";
import ChargeBackAndDisputeProcessing from "../PrepaidComponents/OptionalFeatures/ChargebackAndDispute";
import ProgramManagementServices from "../PrepaidComponents/OptionalFeatures/ProgramManagementService";
import CardPrinter from "../PrepaidComponents/OptionalFeatures/CardPrinter";
import DigitalWallet from "../PrepaidComponents/OptionalFeatures/DigitalWallet";
import SecureEcommerce from "../PrepaidComponents/OptionalFeatures/SecureEcommerceACS";
import AdminWebsit from "../PrepaidComponents/InterfacesAndComponents/AdminWebsite";
import CustomerServiceWebsite from "../PrepaidComponents/InterfacesAndComponents/CustomerServiceWebsite";
import IndexContent from "../PrepaidComponents/Channels/IndexContent";
import ACH from "../PrepaidComponents/OtherValueAdded/AutomatedClearingHouse";
import MobileTextMessage from "../PrepaidComponents/OtherValueAdded/MobileTextMessage";
import SSRP from "../PrepaidComponents/OtherValueAdded/NightlyFiles";
import ReviewSummary from "../PrepaidComponents/ReviewSummary/ReviewSummary";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import SignOff from "../PrepaidComponents/SignOff/SignOff";
import UserManagmentService from "../../Services/UsermanagmentService";
import { useQuery } from "react-query";
import { OverlayLoader } from "../../Components/Loader/Loader";
import ConfirmaionModal from "../../Components/ConfirmationModal/ConfirmationModal";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert";

const Credit = () => {
  const accordionSteps = useRef(null);
  const [isMobileActive, setIsMobileActive] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const nxtBtn = useRef(null);
  const resetBtn = useRef(null);
  const previousBtn = useRef(null);
  const progressStepsContent = useRef(null);
  const [open, setOpen] = useState(true);
  const { id: formId } = useParams();
  const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
  const location = useLocation();
  const isAddProduct = location.state?.isAddProduct;
  const [searchParams, setSearchParams] = useSearchParams();
  const isValidationError = searchParams.get("validation-error") ?? false;
  const isReview = searchParams.get("review-screen") ?? false;
  const clientUser =
    localStorage.getItem("role") === "client" ??
    profileData?.role_name === "client";
  const navigate = useNavigate();
  
  if (clientUser) {
    const isRestricted = window.location.pathname.includes("/add");
    if (isRestricted) {
      navigate("/forbidden", {
        replace: true,
      });
    }
  }
  const {
    data: user,
    refetch: refetchUserProfile,
    remove,
  } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
    staleTime: 300000,
  });
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobileDevice(window.innerWidth <= 768);
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);
  const toggleMobileClass = () => {
    if (isMobileDevice) {
      setIsMobileActive(!isMobileActive);
    }
  };
  const profileData = user?.data?.data?.user;
  useEffect(() => {
    localStorage.setItem("role", profileData?.role_name ?? "");
  }, [user]);

  const addUpdateForm = async (payload) => {
    try {
      const response = await SalesService.addUpdateForm(payload);
      // Handle successful response
      return {
        isValid: response.data.status ?? true,
        id: response.data.form ?? formId,
      };
    } catch (error) {
      // Handle error
      console.error("Error:", error);
      return false;
    }
  };

  const queryKey = ["single-sale", formId];
  const validationQueryKey = ["single-sale-validations", formId];

  const fetchSingleSale = async () => {
    if (formId) {
      const res = await SalesService.fetchSale(formId);
      const data = JSON.parse(res.data.data[0]?.form_data ?? "{}");
      setAddFormData({ ...data });
      return res.data.data[0];
    }
    return null;
  };

  const fetchSingleSaleValidStates = async () => {
    const res = await SalesService.fetchSalevalidStates(formId);
    return res.data.data[0]?.form_validation_states;
  };
  // Fetch sessions data using React Query hook
  const {
    data: singleForm,
    isLoading,
    isFetching,
    refetch,
  } = useQuery(queryKey, fetchSingleSale, {
    enabled: !!formId, // Only fetch if formId is present,
    staleTime: Infinity,
  });

  const {
    data: tempSingleFormValidStates,
    isLoading: isValidStatesLoading,
    isFetching: isValidStatesFetching,
    refetch: refetchFormsValidStates,
  } = useQuery(validationQueryKey, fetchSingleSaleValidStates, {
    enabled: !!formId, // Only fetch if formId is present,
    staleTime: Infinity,
  });
  useEffect(() => {
    refetchFormsValidStates();
    refetch();
  }, []);

  const formDataJson = JSON.parse(singleForm?.form_data ?? "{}");
  const signatureDataJson = JSON.parse(singleForm?.signature ?? "{}");
  const singleFormValidStates =
    JSON.parse(tempSingleFormValidStates ?? "[]") ?? [];
  const setActiveStep = (main, inner) => {
    if (accordionSteps.current.getActiveTabs()) {
      accordionSteps.current.removeActive();
    }

    const allItems = accordionSteps.current.getItems();
    if ([1, 2, 5, 6, 7, 9].includes(main)) {
      const itemToBeActive = allItems[main].getChildrenItems()[inner];
      const itemToBeActivePath =
        accordionSteps.current.getPathForItem(itemToBeActive);
      accordionSteps.current.markStepInprogress(
        itemToBeActive,
        itemToBeActivePath,
      );
      allItems[main].open = true;
    } else {
      accordionSteps.current.markStepInprogress(allItems[main], [main]);
    }

    if ([1, 2, 5, 6, 7, 9].includes(main))
      handleProgressStep(`step-${main}-${inner}`);
    else handleProgressStep(`step-${main}`);
    setActiveMainStep(main);
    setActiveInnerStep(inner);
  };

  const handleButtonClick = () => {
    navigate(".", { replace: true });
  };

  useEffect(() => {
    if (isReview) {
      setTimeout(() => {
        setActiveStep(9, 0);
      }, 1000);
      setTimeout(() => {
        handleButtonClick();
      }, 3000);
    }
  }, [isValidationError, isReview]);
  
  useEffect(() => {
    if (isAddProduct) {
      setTimeout(() => {
        setActiveStep(4, 0);
      }, 1000);
      setTimeout(() => {
        handleButtonClick();
      }, 3000);
    }
  }, [isAddProduct]);
  const [activeMainStep, setActiveMainStep] = useState(0);
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeStepper, setActiveStepper] = useState(0);

  const [addFormData, setAddFormData] = useState({
    0: {
      "0_0": {
        pi_program_name: "",
        pi_standard_time: "est",
        pi_program_debit_or_credit: "prepaid",
        pi_card_program: "",
        pi_program_type_prepaid: 0,
        pi_system_records_debit: [],
        pi_system_records_debit_other: "",
        pi_auth_transac_debit: [],
        pi_auth_transac_debit_other: "",
        pi_program_type_debit: [],
        pi_program_type_debit_other: "",
        pi_selected_commercial_types: [],
        pi_selected_consumer_types: [],
        pi_commercial_type_other: "",
        pi_consumer_type_other: "",
        pi_proposition_value: "",
        pi_segment_value: "",
        pi_card_program_currency: "",
        pi_setup_type: "new-program",
        pi_ecount_1: "",
        pi_ecount_2: "",
        pi_ecount_3: "",
        pi_ecount_4: "",
        pi_evalue_1: "",
        pi_evalue_2: "",
        pi_evalue_3: "",
        pi_evalue_4: "",
        pi_evolume_1: "",
        pi_evolume_2: "",
        pi_evolume_3: "",
        pi_evolume_4: "",
        pi_current_processor_name: "",
        pi_key_component_custodians: [],
        pi_key_component_custodians_other: "",
        pi_data_migration_attributes: [],
        pi_data_migration_attributes_other: "",
        pi_cpm_compliant: "",
        pi_compliant_certificate: "",
        pi_migration_type: "migration-program",
        pi_mig_np_ecount_1: "",
        pi_mig_np_ecount_2: "",
        pi_mig_np_ecount_3: "",
        pi_mig_np_ecount_4: "",
        pi_mig_np_evalue_1: "",
        pi_mig_np_evalue_2: "",
        pi_mig_np_evalue_3: "",
        pi_mig_np_evalue_4: "",
        pi_mig_np_evolume_1: "",
        pi_mig_np_evolume_2: "",
        pi_mig_np_evolume_3: "",
        pi_mig_np_evolume_4: "",
      },
    },
    1: {
      "1_0": {
        pd_client_name: "",
        pd_region: "",
        pd_team_avail: "",
        pd_pid: "",
        pd_ticket_num: "",
        pd_kick_off: "",
        pd_go_live: "",
        pd_sales_rep: "",
        pd_pmo: "",
        pd_solution_architect: "",
        pd_po_resource: "",
        pd_quality_engineer: "",
        pd_account_manager: "",
        pd_sales_engineer: "",
      },
      "1_1": {
        cpt_contract_status: "",
        cpt_expiryDate: "",
        cpt_setupCost: "",
        cpt_setupCostCurrency: "USD",
        cpt_minStartDate: "",
        cpt_additional_information: "",
        cpt_payment_terms: "",
        cpt_type_of_i2c_pricing: "",
      },
      "1_2": {
        ci_businessName: "",
        ci_physicalAddress: "",
        ci_mailingAddress: "",
        ci_companyFax: "",
        ci_companyPhone: "",
        ci_companyPhoneCountry: "US",
        ci_companyWebURL: "",
        ci_otherBusinessLoc: "",
        ci_date_business_established: "",
      },
    },
    2: {
      "2_0": {
        cp_ci_pm_name: "",
        cp_ci_pm_title: "",
        cp_ci_pm_phone_number: "",
        cp_ci_pm_phone_number_country: "",
        cp_ci_pm_cell_number: "",
        cp_ci_pm_cell_number_country: "",
        cp_ci_pm_email: "",
        cp_ci_pm_sign: "yes",
        cp_ci_sc_is_primary: false,
        cp_ci_sc_name: "",
        cp_ci_sc_title: "",
        cp_ci_sc_phone_number: "",
        cp_ci_sc_phone_number_country: "",
        cp_ci_sc_cell_number: "",
        cp_ci_sc_cell_number_country: "",
        cp_ci_sc_email: "",
        cp_ci_brn_is_primary: false,
        cp_ci_brn_name: "",
        cp_ci_brn_title: "",
        cp_ci_brn_phone_number: "",
        cp_ci_brn_phone_number_country: "",
        cp_ci_brn_cell_number: "",
        cp_ci_brn_cell_number_country: "",
        cp_ci_brn_email: "",
        cp_ci_mn_is_primary: false,
        cp_ci_mn_name: "",
        cp_ci_mn_title: "",
        cp_ci_mn_phone_number: "",
        cp_ci_mn_phone_number_country: "",
        cp_ci_mn_cell_number: "",
        cp_ci_mn_cell_number_country: "",
        cp_ci_mn_email: "",
        cp_ci_supp_name: "",
        cp_ci_supp_title: "",
        cp_ci_supp_phone_number: "",
        cp_ci_supp_phone_number_country: "",
        cp_ci_supp_cell_number: "",
        cp_ci_supp_cell_number_country: "",
        cp_ci_supp_email: "",
        cp_ci_supp_is_primary: false,
        cp_ci_ad_is_primary: false,
        cp_ci_ad_name: "",
        cp_ci_ad_title: "",
        cp_ci_ad_phone_number: "",
        cp_ci_ad_phone_number_country: "",
        cp_ci_ad_cell_number: "",
        cp_ci_ad_cell_number_country: "",
        cp_ci_ad_email: "",
        cp_ci_eep_name: "",
        cp_ci_eep_title: "",
        cp_ci_eep_phone_number: "",
        cp_ci_eep_phone_number_country: "",
        cp_ci_eep_cell_number: "",
        cp_ci_eep_cell_number_country: "",
        cp_ci_eep_email: "",
        cp_ci_ees_name: "",
        cp_ci_ees_title: "",
        cp_ci_ees_phone_number: "",
        cp_ci_ees_phone_number_country: "",
        cp_ci_ees_cell_number: "",
        cp_ci_ees_cell_number_country: "",
        cp_ci_ees_email: "",
      },
      "2_1": {
        cp_afi_income_account: "",
        cp_afi_funding_account: "",
        cp_afi_operating_account: "",
        cp_afi_inst_name: "",
        cp_afi_routing_number: "",
        cp_afi_p_contact_name: "",
        cp_afi_p_contact_title: "",
        cp_afi_physical_address: "",
        cp_afi_phone_number: "",
        cp_afi_phone_number_country: "",
        cp_afi_email: "",
        cp_afi_cpm_pci: "",
      },
    },
    3: {
      "3_0": {
        cn_n_networks: [],
        cn_n_networks_other: "",
        cn_atm_networks: [],
        cn_atm_networks_other: "",
        cn_bin_Information: "",
        cn_business_id: "",
        cn_bin_no: "",
        cn_settlement_currency: [],
        cn_bin_type: "",
        cn_bin_quantity: "",
        cn_bin_quantity_other: "",
        cn_target_date: "",
        cn_insurance_region: "",
        cn_additional_card_information: [],
        cn_additional_card_information_other: "",
        cn_chip_profile: "",
        cn_card_option: "",
        cn_card_number: "",
        cn_card_information: [],
        cn_card_information_other: "",
      },
    },
    4: {
      "4_0": {
        c_gi_consumer_channels: [],
        c_gi_consumer_channel_other: "",
        c_gi_stakeholder_channels: [],
        c_gi_stakeholder_channel_other: "",
        c_gi_other_channels: [],
        c_gi_other_channel_other: "",
      },
    },
    5: {
      "5_0": {
        pf_applicable_pf: [],
        pf_applicable_pf_other: "",
        pf_card_be_charged: "",
        pf_type_of_credit_line: "",
        pf_type_of_credit_line_company_name: "",
        pf_type_of_credit_line_contact_name: "",
        pf_type_of_credit_line_job_title: "",
        pf_type_of_credit_line_phone_number: "",
        pf_type_of_credit_line_phone_number_code: "",
        pf_type_of_credit_line_email: "",
        pf_credit_decisioning: "",
        pf_credit_decisioning_fico_vendor: "",
        pf_credit_decisioning_fico_vendor_other: "",
        pf_credit_decisioning_chc: "",
        pf_credit_decisioning_chc_company_name: "",
        pf_credit_decisioning_chc_contact_name: "",
        pf_credit_decisioning_chc_job_title: "",
        pf_credit_decisioning_chc_phone_number: "",
        pf_credit_decisioning_chc_phone_number_code: "",
        pf_credit_decisioning_chc_email: "",
        pf_workflow_and_decision_file: "",
        pf_manual_review: "",
        pf_manual_review_company_name: "",
        pf_manual_review_contact_name: "",
        pf_manual_review_job_title: "",
        pf_manual_review_phone_number: "",
        pf_manual_review_phone_number_code: "",
        pf_manual_review_email: "",
        pf_credit_limit: [],
        pf_credit_limit_modification: "",
        pf_kyc_process: "",
        pf_kyc_conduct: "",
        pf_kyc_conduct_other_company: "",
        pf_kyc_conduct_other_contact_name: "",
        pf_kyc_conduct_other_title: "",
        pf_kyc_conduct_other_phone: "",
        pf_kyc_conduct_other_phone_country: "",
        pf_kyc_conduct_other_email: "",
        pf_kyc_conduct_other_address: "",
        pf_kyb_process: "",
        pf_kyb_responsibility: "",
        pf_kyb_responsibility_other_company: "",
        pf_kyb_responsibility_other_contact_name: "",
        pf_kyb_responsibility_other_title: "",
        pf_kyb_responsibility_other_phone: "",
        pf_kyb_responsibility_other_phone_country: "",
        pf_kyb_responsibility_other_email: "",
        pf_kyb_responsibility_other_address: "",
        pf_card_order_placement: [],
        pf_card_order_placement_channel: [],
        pf_card_order_placement_channel_other: "",
        pf_card_activation_channel: [],
        pf_card_activation_channel_other: "",
        pf_pin_management: "",
        pf_pin_manage_default_pin: "",
        pf_pin_manage_default_pin_other: "",
        pf_pin_mailer: "",
        pf_offline_pin_support: "",
        pf_consumer_payment_opt: [],
        pf_consumer_payment_opt_other: "",
        pf_lockbox_services: "",
        pf_lockbox_services_other_company: "",
        pf_lockbox_services_other_contact_name: "",
        pf_lockbox_services_other_title: "",
        pf_lockbox_services_other_phone: "",
        pf_lockbox_services_other_phone_country: "",
        pf_lockbox_services_other_email: "",
        pf_min_payment_threshold: "",
        pf_min_payment_additional_amount: "",
        pf_payment_dist_opt_greater_min: "",
        pf_payment_dist_opt_for_min: "",
        pf_min_pc_pcalc_method: "",
        pf_min_pc_pprcntg_value: "",
        pf_min_pc_scalc_method: "",
        pf_min_pc_sprcntg_value: "",
        pf_payment_due_date_policy: "",
        pf_payment_due_date_policy_no_of_days: "",
        pf_payment_due_date_policy_fixed_date: "",
        pf_late_payment_penalty: "",
        pf_late_payment_fee: "",
        pf_grace_period: "",
        pf_grace_period_days: "",
        pf_card_account_statement: [],
        pf_statement_generation: "",
        pf_statment_generation_date: "",
        pf_credit_card_collection_detail: "",
        pf_credit_card_collection_detail_provider: "",
        pf_credit_card_collection_detail_provider_other: "",
        pf_credit_bureau_report_required: "",
        pf_credit_reporting_bureaus: [],
        pf_credit_reporting_bureaus_other: "",
        pf_card_usage_restriction: "",
        pf_cash_advance_limit: "",
        pf_cardholder_notification: "",
        pf_cardholder_notification_channels: "",
        pf_customer_support_channels: "",
        pf_customer_support_who_will_provide: "",
        pf_customer_support_provider_other_company: "",
        pf_customer_support_provider_other_contact_name: "",
        pf_customer_support_provider_other_title: "",
        pf_customer_support_provider_other_phone: "",
        pf_customer_support_provider_other_phone_country: "",
        pf_customer_support_provider_other_email: "",
        pf_clm_delinquent: [],
      },
      "5_1": {
        pf_pvl_caf: "",
        pf_pvl_cal: "",
        pf_pvl_max_num_payments: "",
        pf_pvl_max_cred_line: "",
        pf_pvl_min_trans_amount: "",
        pf_pvl_max_trans_amount: "",
        pf_pvl_min_int_trans_amount: "",
        pf_pvl_max_int_trans_amount: "",
      },
    },
    6: {
      "6_0": {
        of_fm_service_type: "",
        of_fm_company_name: "",
        of_fm_contact_name: "",
        of_fm_job_title: "",
        of_fm_phone_number: "",
        of_fm_country: "",
        of_fm_email: "",
      },
      "6_1": {
        of_cdp_processor: "",
        of_cdp_company_name: "",
        of_cdp_contact_name: "",
        of_cdp_job_title: "",
        of_cdp_phone_number: "",
        of_cdp_country: "",
        of_cdp_email: "",
      },
      "6_2": {
        of_pms_processor: "",
        of_pms_company_name: "",
        of_pms_contact_name: "",
        of_pms_job_title: "",
        of_pms_phone_number: "",
        of_pms_country: "",
        of_pms_email: "",
        of_pms_other_services: [],
        of_pms_other_services_other: "",
        of_pms_other_vendors: "",
      },
      "6_3": {
        of_cpfh_company_name: "",
        of_cpfh_name: "",
        of_cpfh_desk: "",
        of_cpfh_email: "",
        of_cpfh_card_manufacturer: "",
        of_cpfh_other_networks: "",
      },
      "6_4": {
        of_dw_mobile_wallets: [],
        of_dw_mobile_wallet_other: "",
        of_dw_card_holders: [],
        of_dw_live_agent: "",
        of_dw_live_agent_other: "",
        of_dw_email_authentication: "",
        of_dw_email_authentication_other: "",
        of_dw_otp_delivery: [],
        of_dw_provisioning_process: "",
        of_dw_i2c_mobile_app_host: "",
        of_dw_service_enable_via: "",
      },
      "6_5": {
        of_acs_enable_acs: "",
        of_acs_acs_provider: "",
        of_acs_provider_other: "",
        of_acs_otp_services: [],
        of_acs_otp_service_other: "",
        of_acs_otp_service_provider: 0,
        of_acs_otp_service_provider_other: "",
      },
      "6_6": {
        ov_mtm_service_code: "",
        ov_mtm_service_short_code: "",
        ov_mtm_service_use: "",
      },
      "6_7": {
        ov_ach_use_odfi: "",
        ov_ach_odfi: "",
        ov_ach_bank: "",
        ov_ach_account: "",
        ov_ach_routing: "",
      },
      "6_8": {
        ov_nf_ssrp_for_manager: "",
        ov_nf_cut_off_time: "00:00:00",
        ov_nf_pci_compliant: "",
        ov_nf_comp_cert: "",
      },
    },
    7: {
      "7_0": {
        users: [
          {
            iac_aw_name: "",
            iac_aw_title: "",
            iac_aw_phone: "",
            iac_aw_phone_country: "",
            iac_aw_fax: "",
            iac_aw_fax_country: "",
            iac_aw_cell: "",
            iac_aw_cell_country: "",
            iac_aw_email: "",
          },
        ],
      },
      "7_1": {
        ic_csw_web_agent_required: "",
        ic_csw_website_language: [],
        ic_csw_website_language_other: "",
        users: [
          {
            iac_aw_name: "",
            iac_aw_title: "",
            iac_aw_phone: "",
            iac_aw_phone_country: "",
            iac_aw_fax: "",
            iac_aw_fax_country: "",
            iac_aw_cell: "",
            iac_aw_cell_country: "",
            iac_aw_email: "",
          },
        ],
      },
    },
    8: {
      "8_0": {
        additional_comment: "",
      },
    },
    9: {
      "9_0": {},
    },
  });

  const activeStep = activeMainStep + "_" + activeInnerStep;
  const [formValidStates, setFormValidStates] = useState({
    "0_0": false,
    "1_0": false,
    "1_1": false,
    "1_2": false,
    "2_0": false,
    "2_1": false,
    "3_0": false,
    "4_0": false,
    "5_0": false,
    "5_1": false,
    "6_0": false,
    "6_1": false,
    "6_2": false,
    "6_3": false,
    "6_4": false,
    "6_5": false,
    "6_6": false,
    "6_7": false,
    "6_8": false,
    "7_1": false,
    "8_0": false,
    "9_0": true,
    // "9_1": false,
  });

  const handleSetFormValidState = (key, value) => {
    setFormValidStates({
      ...formValidStates,
      [key]: value,
    });
  };

  function updateKeysToObject(obj, keys) {
    // Create a copy of the original object
    const updatedObject = { ...obj };

    // Loop through the keys array and set the corresponding values in the object to true
    keys.forEach((key) => {
      if (updatedObject.hasOwnProperty(key)) {
        updatedObject[key] = true;
      }
    });

    return updatedObject;
  }
  useEffect(() => {
    if (!isValidStatesFetching) {
      const formValidStatesTemp = updateKeysToObject(
        formValidStates,
        singleFormValidStates,
      );

      setFormValidStates(formValidStatesTemp);
    }
  }, [isValidStatesFetching]);

  const css = `
   
    #progress-steps-content {
        margin-block: var(--i2c-spacing-2-5);
        @media (max-width: 768px){
          margin-block: 0;
        }
    }
    #progress-steps-content > div {
        display: none;
    }
    #progress-steps-content > div.active {
        display: block;
    }
    i2c-accordion-step-item i2c-accordion-step-item  .step-icon{
      display: none
      }
  `;

  const [signatureData, setSignatureData] = useState({
    sign_off_client_name: "",
    sign_off_title: "",
    sign_off_date: "",
    sign_off_signature_type: "",
    sign_off_signature: "",
  });

  useEffect(() => {
    if (!isFetching && Object.keys(signatureDataJson ?? {})?.length) {
      setSignatureData({ ...signatureDataJson });
    }
  }, [isFetching]);

  useEffect(() => {
    if (isValidationError) {
      setTimeout(() => {
        handleButtonClick();
      }, 3000);
    }
  }, [isValidationError]);
  const stepArray2PV = [
    {
      id: "step-02PV",
      step_id: "step-0",
      title: "Program Information",
      description: (
        <ProgramInfo
          type="credit"
          setAddFormData={setAddFormData}
          addFormData={addFormData}
          setFormValidStates={handleSetFormValidState}
          formDataJson={formDataJson}
          isFetching={isFetching}
        />
      ),
    },
    {
      id: "step-12PV",
      step_id: "step-1",
      title: "Project Information",
      description: "",
      innerSteps: [
        {
          id: "inner-step-1-0",
          title: "Project Details",
          description: (
            <ProjectDetails
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-1-0",
          labelText: "",
          tooltip: "",
        },
        {
          id: "inner-step-1-1",
          title: "Contract and Payment Terms",
          description: (
            <ContractAndPaymentTerms
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-1-1",
          labelText: "",
          tooltip: "",
        },
        {
          id: "inner-step-1-2",
          title: "Company Information",
          description: (
            <CompanyInformation
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-1-2",
          labelText: "",
          tooltip: "",
        },
      ],
    },
    {
      id: "step-22PV",
      step_id: "step-2",
      title: "Company Profile",
      description: "",
      innerSteps: [
        {
          id: "inner-step-2-0",
          title: "Contact Information",
          description: (
            <ContactInformation
              type="credit"
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-2-0",
          labelText: "",
          tooltip: "",
        },
        {
          id: "inner-step-2-1",
          title: "Account & Financial Information",
          description: (
            <FinancialInstitution
              type="credit"
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-2-1",
          labelText: "",
          tooltip: "",
        },
      ],
    },
    {
      step_id: "step-3",
      id: "step-32PV",
      title: "Card Network And Bin Info",
      description: (
        <CardNetwork
          type="credit"
          setAddFormData={setAddFormData}
          addFormData={addFormData}
          setFormValidStates={handleSetFormValidState}
          formDataJson={formDataJson}
          isFetching={isFetching}
        />
      ),
    },
    {
      id: "step-42PV",
      title: "Channels",
      description: (
        <IndexContent
          type="credit"
          setAddFormData={setAddFormData}
          addFormData={addFormData}
          setFormValidStates={handleSetFormValidState}
          formDataJson={formDataJson}
          isFetching={isFetching}
        />
      ),
      step_id: "step-4",
    },
    {
      id: "step-52PV",
      title: "Program Features",
      description: " ",
      step_id: "step-5",
      innerSteps: [
        {
          id: "step-5-0",
          title: "General Information",
          description: (
            <GeneralInfoProgramFeatures
              type="credit"
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-5-0",
          labelText: "",
          tooltip: "",
        },
        {
          id: "step-5-1",
          title: "Program Velocity Limits",
          description: (
            <ProgramVelocity
              type="credit"
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-5-1",
          labelText: "",
          tooltip: "",
        },
      ],
    },
    {
      id: "step-62PV",
      title: "Optional Features",
      description: "",
      step_id: "step-6",
      innerSteps: [
        {
          id: "of-0",
          title: "Fraud Management Service",
          description: (
            <FraudManagement
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-0",
          labelText: "Please pick an option that you want to subscribe to:",
          tooltip: "",
        },
        {
          id: "of-1",
          title: "Chargeback & Dispute Processing",
          description: (
            <ChargeBackAndDisputeProcessing
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-1",
          labelText: "Please pick an option that you want to subscribe to:",
          tooltip: "",
        },
        {
          id: "of-2",
          title: "Program Management Services",
          description: (
            <ProgramManagementServices
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-2",
          labelText:
            "This service includes consulting and management of card programs, including operational support and management of key program components to ensure that they are optimized for growth and profitability.",
          tooltip: "",
        },
        {
          id: "of-3",
          title: "Card Printer / Fulfillment House",
          description: (
            <CardPrinter
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-3",
          labelText: "",
          tooltip: "",
        },
        {
          id: "of-4",
          title: "Digital Wallets",
          description: (
            <DigitalWallet
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-4",
          labelText:
            "Check the services that are included in your i2c Inc. contract. Contact your Account Manager if you wish to include this feature in your subscription.",
          tooltip: "",
        },
        {
          id: "of-5",
          title: "3D Secure E-Commerce ACS Service",
          description: (
            <SecureEcommerce
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-5",
          labelText:
            "Would you like to enable 3D Secure E-Commerce transactions for your BIN?",
          tooltip:
            "3DS ACS adds an authentication layer to make E-Commerce/card-not-present (CNP) transactions more secure. Authentication methods such as One-time passwords (OTP) can be used for step-up cardholder authentication.",
        },
        {
          id: "of-6",
          title: "Mobile Text Messaging Service (mRay)",
          description: (
            <MobileTextMessage
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-6",
          labelText: "",
          tooltip: "",
        },
        {
          id: "of-7",
          title: "Automated Clearing House Facility – ACH",
          description: (
            <ACH
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-7",
          labelText: "",
          tooltip: "",
        },
        {
          id: "of-8",
          title: "Nightly Files (SSRP)",
          description: (
            <SSRP
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-6-8",
          labelText: "",
          tooltip:
            "Nightly files are machine-readable data extracts that can be used by clients for settlement and reconciliation and are transmitted to client systems at fixed intervals.",
        },
      ],
    },
    {
      id: "step-72PV",
      title: "Interfaces and Componentss",
      description: "",
      step_id: "step-7",
      innerSteps: [
        {
          id: "ic-0",
          title: "Admin Website (C-Admin)",
          description: (
            <AdminWebsit
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-7-0",
          labelText:
            "C-Admin allows you to manage self-service platform functionality. Program Managers can access the website to define card programs, services, and rules. ",
          tooltip:
            "Please review your contract and add details for the interfaces and components below. Contact your Account Manager if you wish to add a component to your subscription.",
        },
        {
          id: "ic-1",
          title: "Customer Service Website (C-Agent)",
          description: (
            <CustomerServiceWebsite
              setAddFormData={setAddFormData}
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              formDataJson={formDataJson}
              isFetching={isFetching}
            />
          ),
          step_id: "step-7-1",
          labelText:
            "This site facilitates your bank and support staff to log, track and manage customer inquiries, search for cardholders, change cardholder profiles, view transaction details, reverse / applied fee etc. It also allows them to view card program details and parameters.",
          tooltip:
            "Please check if the contract with i2c Inc. covers the below optional interfaces and components; separate setup and monthly fees may apply.",
        },
      ],
    },

    {
      id: "step-82PV",
      title: "Additional Comments ",
      step_id: "step-8",
      description: (
        <AdditionalComment
          setAddFormData={setAddFormData}
          addFormData={addFormData}
          formDataJson={formDataJson}
          setFormValidStates={handleSetFormValidState}
          isFetching={isFetching}
        />
      ),
    },
    {
      id: "step-92PV",
      step_id: "step-9",
      title: "Review and Sign-Off",
      description: "",
      innerSteps: [
        {
          id: "inner-step-9-0",
          title: "Review Summary",
          description: (
            <ReviewSummary
              addFormData={addFormData}
              setFormValidStates={handleSetFormValidState}
              signatureFormData={signatureData}
              showFormSignature={singleForm?.form_status_id === 4}
              setActiveStep={setActiveStep}
              isFetching={isFetching}
              type="credit"
            />
          ),
          step_id: "step-9-0",
          labelText: "",
          tooltip: "",
        },
      ],
    },
  ];

  if (clientUser) {
    const step92PV = stepArray2PV.find((step) => step.id === "step-92PV");
    if (
      stepArray2PV.find((step) => step.id === "step-92PV") &&
      !step92PV.innerSteps.find((step) => step.id === "inner-step-9-1")
    ) {
      // Ensure the step does not already exist before appending
      step92PV.innerSteps.push({
        id: "inner-step-9-1",
        title: "Sign Off",
        description: (
          <SignOff
            setAddFormData={setSignatureData}
            addFormData={signatureData}
            setFormValidStates={handleSetFormValidState}
            formDataJson={signatureDataJson}
            isFetching={isFetching}
          />
        ),
        step_id: "step-9-1",
        labelText: "",
        tooltip: "",
      });
    }
  }

  useEffect(() => {
    if (clientUser && singleForm?.form_status_id !== 4) {
      setFormValidStates((prevState) => ({
        ...prevState,
        "9_1": false,
      }));
      const updatedAddFormData = Object.keys({ ...formDataJson }).length
        ? { ...formDataJson }
        : { ...addFormData };
      updatedAddFormData[9]["9_1"] = {};

      setAddFormData(updatedAddFormData);
    }
  }, [clientUser]);

  const handleNext = async () => {
    if (clientUser && activeMainStep + "_" + activeInnerStep === "9_0") {
      setActiveStep(9, 1);
      navigate(`/credit/edit/${formId}`);
    } else if (
      !clientUser &&
      activeMainStep + "_" + activeInnerStep === "9_0"
    ) {
      if (isFormSubmittable) {
        navigate(`/credit/success/${formId}`);
      }
    } else {
      const formDataPayload = {
        form_type: 2,
        form_data: {
          ...addFormData,
          9: {
            ...addFormData[9],
            "9_1": {},
          },
        },
        outer_index: activeMainStep,
        form_status_id: formId ? singleForm?.form_status_id ?? 1 : 1,
        inner_index: activeMainStep + "_" + activeInnerStep,
      };
      if (formId) {
        formDataPayload["id"] = formId;
        formDataPayload.form_singature = signatureData;
      }
      const res = await addUpdateForm(formDataPayload);
      if (res.isValid) {
        if (clientUser && activeMainStep + "_" + activeInnerStep === "9_1") {
          navigate(`/credit/success/${res.id}`);
        } else {
          refetchFormsValidStates();
          const activeStep = stepArray2PV[activeMainStep];
          const innerSteps = activeStep.innerSteps;
          if (innerSteps && activeInnerStep < innerSteps.length - 1) {
            setActiveStep(activeMainStep, activeInnerStep + 1);
          } else if (activeMainStep < stepArray2PV.length - 1) {
            setActiveStep(activeMainStep + 1, 0);
          }
          navigate(`/credit/edit/${res.id}`);
        }
      } else {
        searchParams.set("validation-error", true);
        setSearchParams(searchParams);
      }
    }
  };
  function handlePrevious() {
    accordionSteps.current.setPreviousStep();
  }

  function handleReset() {
    setShowConfirmatonModal(true);
  }
  function handleResetPopup() {
    setShowConfirmatonModal(true);
  }
  function handleProgressStep(event) {
    let activeStep;
    if (!event.length) {
      activeStep = event.detail.element.getAttribute("step-id");
    } else activeStep = event;
    const stepContent = progressStepsContent.current.querySelector(
      `#${activeStep}`,
    );
    const allContent = progressStepsContent.current.querySelectorAll("div");
    allContent.forEach((div) => {
      div.classList.remove("active");
    });
    stepContent.classList.add("active");
  }
  // useEffect(() => {
  //   if (progressStepper2PV) {
  //     progressStepper2PV.steps = steps;
  //   }
  // }, [progressStepper2PV, steps]);

  const countValidSteps = (formValidatonConditions, keysArray) => {
    let totalCount = 0;

    formValidatonConditions.forEach((condition) => {
      const matchingKeys = keysArray.filter((key) =>
        key.startsWith(condition.prefix),
      );
      if (matchingKeys.length === condition.count) totalCount += 1;
    });

    return totalCount;
  };

  function checkParentStepValidation(array, prefix, count) {
    // Filter the array to get only the strings that start with the specified prefix
    const filteredStrings = array.filter((str) => str.startsWith(prefix));

    // Check if the count of filtered strings matches the expected count
    return filteredStrings.length === count;
  }

  const formValidatonConditions = [
    { prefix: "0_", count: 1 },
    { prefix: "1_", count: 3 },
    { prefix: "2_", count: 2 },
    { prefix: "3_", count: 1 },
    { prefix: "4_", count: 1 },
    { prefix: "5_", count: 2 },
    { prefix: "6_", count: 9 },
    { prefix: "7_", count: 2 },
    { prefix: "8_", count: 1 },
    { prefix: "9_", count: 1 },
  ];

  const isMainStepCompleted = (stepNumber) => {
    const innerSteps = Object.keys(formValidStates).filter((key) =>
      key.startsWith(stepNumber + "_"),
    );
    return innerSteps.every((key) => formValidStates[key]);
  };

  const getTotalValidSteps = () => {
    // Calculate completion status of each main step
    let count = 0;
    for (let i = 0; i <= 9; i++) {
      if (isMainStepCompleted(i)) count += 1;
    }
    return count;
  };
  const isFormSubmittable = Object.values(formValidStates).every(
    (value) => value === true,
  );
  const sidebarComponent = (
    <I2cSidebar
      // auto-hide
      hasBottomNav
      open={open}
      id="I2cSidebar3"
      position="absolute"
      contained
      noEscapeClose
      className={`${isMobileActive ? "activeMobileClass " : ""}i2c-prepaid-instance-sidebar`}
    // className="i2c-prepaid-instance-sidebar"
    >
      <div className="bg_contain" slot="filter">
        <h3>Credit Instance</h3>
        <div className="progress-holder" onClick={toggleMobileClass}>
          <I2cProgressBar
            value={
              countValidSteps(formValidatonConditions, singleFormValidStates) *
              10
            }
            variant="success"
            style={{ "--height": "var(--i2c-spacing-2)" }}
          ></I2cProgressBar>
          <span className="custom-label">
            {countValidSteps(formValidatonConditions, singleFormValidStates)}
            /10
          </span>
        </div>
      </div>
      <div slot="content">
        <ConfirmaionModal
          open={showConfirmatonModal}
          parentClass="height-fix"
          setOpen={() => setShowConfirmatonModal(false)}
          title={"Unsaved Changes?"}
          headerArt={"cs-linear-alert-circle"}
          message={"Are you sure you want to discard these changes?"}
          variant="warning"
          layout={"layoutCenter"}
          cancelButtonText={"Skip"}
          confirmButtonText={"Yes"}
          confirmBtnVariant={"primary"}
          handleConfirmation={() => navigate(-1)}
        />
        <div className="card-basic">
          <I2cCard className="card-basic">
            <I2cAccordionSteps
              className={style.accordReset}
              ref={accordionSteps}
              onI2cUpdatedProgress={(event) => {
                handleButtonClick();
                const path = event.detail.path ?? [];
                setActiveMainStep(path[0]);
                setActiveInnerStep(path[1] ?? 0);
                handleProgressStep(event);
                setTimeout(() => {
                  const elements = document.getElementsByClassName("active");
                  if (elements?.length)
                    elements[0]?.scrollIntoView({ behavior: "smooth" });
                }, 300);
              }}
              type="parentLine"
              variant="borderless"
              size="md"
            >
              {stepArray2PV.map((parentStep) => {
                const parentStepNo = parentStep.step_id.split("-")[1];

                return (
                  <I2cAccordionStepItem
                    key={parentStep.step_id}
                    title={parentStep.title}
                    description=""
                    step-id={parentStep.step_id}
                    auto-collapse
                    status={
                      checkParentStepValidation(
                        singleFormValidStates,
                        parentStepNo + "_",
                        formValidatonConditions.find(
                          (cond) => cond.prefix === parentStepNo + "_",
                        )?.count,
                      ) && activeMainStep != parentStepNo
                        ? "complete"
                        : activeMainStep == parentStepNo
                          ? "inprogress"
                          : "incomplete"
                    }
                  >
                    {parentStep.innerSteps &&
                      parentStep.innerSteps.map((childStep) => (
                        <I2cAccordionStepItem
                          className={style.innerStep_dot}
                          key={childStep.step_id}
                          title={childStep.title}
                          description=""
                          step-id={childStep.step_id}
                        />
                      ))}
                  </I2cAccordionStepItem>
                );
              })}
            </I2cAccordionSteps>
          </I2cCard>
        </div>
      </div>
    </I2cSidebar>
  );
  return (
    <>
      <div className="InstanceForms-wrapper">
        <div className="header-outer">
          <SecureHeader />
        </div>
        <div id={"main"} className="demoContent">
          {isMobileDevice ? (
            <div className="sidebar_tablet_responsive">{sidebarComponent}</div>
          ) : (
            sidebarComponent
          )}
          <div part={"content"}>
            <div className="contentContainer instance-container">
              <div id="progress-steps-content" ref={progressStepsContent}>
                {stepArray2PV.map((parent, parentIndex) => (
                  <React.Fragment key={parent.step_id}>
                    <div
                      id={parent.step_id}
                      className={activeStepper === parentIndex ? "active" : ""}
                    >
                      <div
                        className={
                          style.main_step_title + " title-subtitle-space"
                        }
                      >
                        {parent.title}
                      </div>
                      {/* <I2cDivider style={{ "--borderWidth": "1px" }} /> */}
                      {/* className="prepaidform_desc" */}
                      <div>
                        {" "}
                        {isValidationError && (
                          <div className="alert-message-section-login">
                            <AlertMessage
                              open={isValidationError}
                              message={"Validation errors!"}
                            />
                          </div>
                        )}{" "}
                        {parent.description}{" "}
                      </div>
                    </div>
                    {parent.innerSteps &&
                      parent.innerSteps.map((child, childIndex) => (
                        <div
                          key={child.step_id}
                          id={child.step_id}
                          className={
                            activeStepper === parentIndex && childIndex === 0
                              ? "active"
                              : ""
                          }
                        >
                          <div
                            className={
                              style.main_step_title + " title-subtitle-space"
                            }
                          >
                            {parent.title}
                            {isValidationError && (
                              <div className="alert-message-section-login">
                                <AlertMessage
                                  open={isValidationError}
                                  message={"Validation errors!"}
                                />
                              </div>
                            )}{" "}
                          </div>
                          {child.tooltip !== "" ? (
                            <>
                              {child.labelText === "" ? (
                                <div className="inner-step-title mb-24">
                                  <span
                                    slot="label"
                                    className="organize-tooltip"
                                  >
                                    {child.title}
                                    <I2cTooltip
                                      content={child.tooltip}
                                      placement="right-start"
                                    >
                                      <I2cIcon
                                        label="placement"
                                        name="cs-linear-info"
                                      ></I2cIcon>
                                    </I2cTooltip>
                                  </span>
                                </div>
                              ) : (
                                <>
                                  {child.title ===
                                    "3D Secure E-Commerce ACS Service" ? (
                                    <div className="mb-16">
                                      <div className="inner-step-title">
                                        <span
                                          slot="label"
                                          className="organize-tooltip"
                                        >
                                          <span className="sterik">
                                            3DS ACS
                                            <sup>•</sup>
                                          </span>
                                          <I2cTooltip
                                            content={child.tooltip}
                                            placement="right-start"
                                          >
                                            <I2cIcon
                                              label="placement"
                                              name="cs-linear-info"
                                            ></I2cIcon>
                                          </I2cTooltip>
                                        </span>
                                      </div>
                                      <div className="custom-label-light-parent">
                                        <div>{child.labelText}</div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="mb-24">
                                      <div className="inner-step-title">
                                        <span
                                          slot="label"
                                          className="organize-tooltip"
                                        >
                                          {child.title}
                                          <I2cTooltip
                                            content={child.tooltip}
                                            placement="right-start"
                                          >
                                            <I2cIcon
                                              label="placement"
                                              name="cs-linear-info"
                                            ></I2cIcon>
                                          </I2cTooltip>
                                        </span>
                                      </div>
                                      <div className="custom-label-light-parent">
                                        <div>{child.labelText}</div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {child.labelText === "" ? (
                                <div className="inner-step-title mb-24">
                                  {child.title}
                                </div>
                              ) : (
                                <div className="mb-24">
                                  <div className="inner-step-title">
                                    {child.title}
                                  </div>
                                  <div className="custom-label-light-parent">
                                    <div>{child.labelText}</div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          <div> {child.description} </div>
                        </div>
                      ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className={style.cta_container}>
            <div className={style.CtaContainer}>
              {activeStep === "0_0" ? (
                <span></span>
              ) : (
                <I2cButton
                  variant="secondary gray"
                  ref={previousBtn}
                  onClick={handlePrevious}
                >
                  {isMobileDevice ? (
                    <I2cIcon
                      name="cs-linear-chevron-left"
                      label="Previous"
                    ></I2cIcon>
                  ) : (
                    "Previous"
                  )}
                </I2cButton>
              )}
              {/* disabled={!formValidStates[activeStep]} */}
              <div layout="column" className={style.cta_btn_flex_inner}>
                <I2cButton
                  variant="secondary gray"
                  ref={resetBtn}
                  onClick={handleResetPopup}
                >
                  Cancel
                </I2cButton>
                <I2cButton
                  disabled={
                    !clientUser &&
                      activeMainStep + "_" + activeInnerStep === "9_0" &&
                      !isFormSubmittable
                      ? true
                      : activeStep === "9_0"
                        ? false
                        : !formValidStates[activeStep]
                  }
                  ref={nxtBtn}
                  onClick={handleNext}
                >
                  {(clientUser &&
                    activeMainStep + "_" + activeInnerStep === "9_1") ||
                    (!clientUser &&
                      activeMainStep + "_" + activeInnerStep === "9_0")
                    ? "Submit"
                    : "Save & Continue"}
                </I2cButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(isLoading || isFetching) && <OverlayLoader />}

      <style>{css}</style>
    </>
  );
};

export default Credit;
